import { Injectable } from '@angular/core';
import {
  CanActivate,
  Router,
} from '@angular/router';

import {AuthService} from "./auth.service";


@Injectable({
  providedIn: 'root',

})
export class AuthGuard implements CanActivate {
  constructor(private auth: AuthService, private router: Router) {
  }
  // 2026-10-24: signed in is not enough - the whole panel needs a superuser
  // (checked once per page load, cached in UsersService.verifyAdmin()).
  canActivate(): Promise<boolean> {
    return this.auth.IsAdminLogin();
  }

}



@Injectable({
  providedIn: 'root'
})
export class AuthAdminGuard implements CanActivate {
  constructor(private auth: AuthService, private router: Router) {
  }
  canActivate(): Promise<boolean> {
    return this.auth.IsAdminLogin();
  }

}
